import BadgeIcon from "../../../Icons/BadgeIcon";


function Bonus({ entryjson, inputs, setInputs, saveMemberEntry }) {
    //const { showToast } = useToast();

    const entrydet = JSON.parse(entryjson.entry);



    const saveEntry = () => {
        //window.open(entrydet.page_url, '_blank');
        saveMemberEntry();
    }


    return (

        <div className="cursor-default">
            <div className="flex flex-col md:flex-row justify-between">
                <div className="md:w-[440px]">
                    <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 mb-1">{entrydet?.headline}</h4>
                    <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] mb-1">{entrydet?.description}</p>
                </div>
                <div className="hidden min-[426px]:block">
                    <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
            <div className="flex items-center justify-between">
                <div className="pt-2">
                    <button onClick={() => saveEntry()} className={`primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] border  hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]`}>Earn Points</button>
                </div>
                <div className="pt-2">
                    <span class="earn_points_btn bg-white text-[#0274F7] ml-2 text-sm font-medium inline-flex items-center px-3 max-[325px]:px-1 py-1 rounded-md border border-[#0274F7] sm:hidden">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default Bonus;